import { useEffect } from "react";
import { api } from "root";

function SenctionContextProvider({ children }: { children: React.ReactNode }) {
  const checkAuth = async () => {
    try {
      const currentPath = window.location.pathname;
      const publicPaths = ["/access-denied"];
      if (publicPaths.includes(currentPath)) {
        console.log("skipping auth check");
        return;
      }
      const response = await api.auth.checkAuthAccess();
      if (!response.status) {
        window.location.href = "/access-denied";
      }
    } catch (error) {}
  };

  useEffect(() => {
    checkAuth();
  }, []);
  return <div>{children}</div>;
}

export default SenctionContextProvider;
